import { JSX } from 'solid-js';

import { BetslipStatus } from './types';
export interface BetErrorResult {
  localErrCode?: string;
  status: BetslipStatus;
  message: string | JSX.Element;
  failedSelections?: any[];
  limitAmount?: number;
}

export const BET_ERROR_MAP: Record<string, BetErrorResult> = {
  CLOUDFRONT_BLOCKED: {
    status: BetslipStatus.NETWORK_ERROR,
    message: 'Network blocked, please try VPN or change network',
  },

  '10000': { status: BetslipStatus.ERROR, message: '' },
  '10001': { status: BetslipStatus.BET_AMOUNT_TOO_SMALL, message: '' },
  '10002': { status: BetslipStatus.BET_AMOUNT_TOO_LARGE, message: '', failedSelections: [] },
  '10009': { status: BetslipStatus.SINGLE_PARTIALLY_PLACED, message: '' },
  '10010': { status: BetslipStatus.SINGLE_PARTIALLY_PLACED, message: '' },
  '10011': { status: BetslipStatus.ALL_BET_FAILED, message: '' },
  '10012': { status: BetslipStatus.SINGLE_ODDS_PARTIALLY_PLACED, message: '' },
  '10013': { status: BetslipStatus.SINGLE_ODDS_ALL_FAILED, message: '' },
  '10014': { status: BetslipStatus.ALL_BET_FAILED, message: '' }, //custom bet
  '10015': { status: BetslipStatus.SINGLE_PARTIALLY_PLACED, message: '' },
  '10016': { status: BetslipStatus.ALL_BET_FAILED, message: '' },
  '10017': { status: BetslipStatus.ALL_BET_FAILED, message: '' },
  '10018': { status: BetslipStatus.ALL_BET_FAILED, message: '' },

  MBS_REPORT_FAILED: {
    status: BetslipStatus.MBS_REPORT_AILED,
    message: t('Bet placement failed (MBS error)'),
  },

  SERVER_ERROR: {
    status: BetslipStatus.SERVER_ERROR,
    message: t('Server error, please try again later'),
  },

  DEFAULT: {
    status: BetslipStatus.ERROR,
    message: t('Unknown error, please try again'),
  },
};

const createErrorResult = (message: string, fallbackStatus = BetslipStatus.ERROR): BetErrorResult => ({
  // localErrCode: '10000',
  status: fallbackStatus,
  message,
});

export const handleBetError = (error: any): BetErrorResult => {
  console.error('[BetSlip] Place bet failed:', error.raw, error);

  if (!error?.raw) {
    return BET_ERROR_MAP.SERVER_ERROR;
  }

  const { errCode, errMessage, message, data } = error.raw;

  if (errCode === 'CLOUDFRONT_BLOCKED') {
    return BET_ERROR_MAP.CLOUDFRONT_BLOCKED;
  }

  if (data?.localErrCode) {
    const key = String(data.localErrCode);
    const mapItem = BET_ERROR_MAP[key];

    const title = data.userMsgTitle?.trim();
    const subTitle = data.userMsgSubTitle?.trim();
    const combinedMessage = [title, subTitle].filter(Boolean).join('\n') || mapItem.message || 'Unknown error';

    return {
      status: mapItem.status,
      localErrCode: data.localErrCode,
      message: combinedMessage,
      failedSelections: mapItem?.failedSelections ?? data.failedSelections,
      limitAmount: data?.limitAmount ?? 0,
    };
  }

  if (typeof errMessage === 'string' && errMessage.includes('MBS上报失败')) {
    return BET_ERROR_MAP.MBS_REPORT_FAILED;
  }

  // 通用错误
  if (!data) {
    return createErrorResult(errMessage ?? message);
  }

  return BET_ERROR_MAP.DEFAULT;
};
